@if (isAuthenticated | async) {
  <div class="px-3 py-2">
    <label class="form-label small mb-1" for="language-select" i18n>Language</label>
    <select
      id="language-select"
      class="form-select form-select-sm"
      [(ngModel)]="languageService.currentLanguage"
      [ngModelOptions]="{ standalone: true }"
      (change)="setLanguage($event)"
    >
      @for (language of languages; track language.value) {
        <option value="{{ language.value }}">{{ language.text }}</option>
      }
    </select>
  </div>
}
